import React from 'react'
import getURLParams from '../../../helpers/getURLParams'
import customRequest from '../../../helpers/customRequest'
import { initializeFormValidation } from '../../../helpers/forms/form-validation'
import message from '../../../components/message/message'
import redirect from '../../../components/redirect/redirect'
import ClipLoader from 'react-spinners/ClipLoader'

class Share extends React.Component
{
    state = {
        students: [],
        readPermission: true,
        writePermission: true,
        submitting: false
    }
    componentDidMount()
    {
        var params = getURLParams()
        if (!params.students) {
            redirect.send("/students", () => {
                message.error("Please select a student to be shared.")
            })
            return
        }
        this.setState({students: params.students})
        initializeFormValidation(this.onSubmit)
    }

    onSubmit = () => {

        this.setState({submitting: true}, () =>
        {
            var permissions = []

            if (this.state.readPermission) {
                permissions.push("read")
            }

            if (this.state.writePermission) {
                permissions.push("write")
            }

            customRequest.post('/api/students/share', {
                students: this.state.students,
                permissions: permissions,
                shareToCustomer: document.getElementById('username').value
            })
            .then(({data}) => {
                this.setState({submitting: false, loading: false})
                message.clear()
                if (data.valid) {
                    redirect.send("/students")
                    message.success("Permissions have been successfully granted.")
                } else {
                    message.error(data.message)
                }
            })
        })
    }

    render()
    {
        var { students, readPermission, writePermission } = this.state

        return (
        <React.Fragment>
            <h1>Share Student{students.length > 1 ? "s" : ""}</h1> 
            <div class = "row subheader-text">
                <div class = "col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                    <p>Please select a permission type to delegate, and the username of the person to whom you wish to delegate permissions.</p>
                </div>
            </div>

            <form class = "form-horizontal form-validate" noValidate method = "post">
                <div class = "form-group row">
                    <label class = "text-center-xs bold-xs col-sm-3 control-label text-right">Student{students.length > 1 ? "s" : ""}</label>
                    
                    <div class = "col-sm-6">
                        {
                            students.map((student) =>
                            {
                                return <p class = "form-control-static text-left text-center-xs break-words">{student}</p>
                            })
                        }
                    </div>
                </div>
                
                <div class = "form-group row">
                    <label class = "col-sm-3 control-label text-right text-right">Permissions</label>
                    
                    <div class = "col-sm-6 text-left">
                        <div class = "checkbox">
                            <label>
                                <input type = "checkbox" id = "permission-read" name = "permissions[]" value = "read" checked={readPermission} onChange={() => { this.setState({readPermission: !readPermission}) }} />
                                
                                <span className="pl-2">View Charting Data</span>
                            </label>
                        </div>
                        
                        <div class = "checkbox">
                            <label>
                                <input type = "checkbox" id = "permission-write" name = "permissions[]" value = "write" checked={writePermission} onChange={() => { this.setState({writePermission: !writePermission}) }} />
                                
                                <span className="pl-2">Complete Exercises with Student</span>
                            </label>
                        </div>
                    </div>
                </div>
                
                <div class = "form-group row">
                    <label for = "username" class = "d-none d-sm-inline col-sm-3 control-label text-right">Username</label>
                    
                    <div class = "col-sm-6">
                        <input type = "text" disabled={this.state.submitting} class = "form-control" id = "username" name = "username" placeholder = "Username" required autofocus data-description = "enter a username" />
                    </div>
                </div>
                
                <button type = "submit" disabled={this.state.submitting} class = "btn btn-secondary btn-lg">{this.state.submitting ?
                    <ClipLoader
							size={20}
							color={"#123abc"}
							loading={this.state.submitting}
							/> : "Share"}</button>
            </form>
        </React.Fragment>)
    }
}

export default Share
